//
//
//
//
//
//

import dynamicTitle from './directives/vue-dynamic-title';
export default {
    name: 'App',
    mixins: [dynamicTitle]
}



// WEBPACK FOOTER //
// ./src/App.vue